import { createFileRoute, Outlet } from "@tanstack/react-router";
import DashboardLayout from "@/layouts/dashboard-layout";
import { useEffect, useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import useAuthStore from "@/store/useAuthStore";
import { ApiService } from "@/services/api-service";
import { VerifyOTP } from "@/components/verify-email";
import { LogoLoader } from "@/components/logo-loader";

export const Route = createFileRoute("/app/_layout")({
  component: Layout,
});

function Layout() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { isLoggedIn, user } = useAuthStore();

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!isLoggedIn) {
        navigate({ to: "/auth/login" });
      } else {
        setLoading(false);
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    async function sendOTP() {
      await ApiService.sendOTP(user?.email as string);
    }
    if (!user?.is_email_verified && isLoggedIn) {
      sendOTP();
    }
  }, [user?.email, user?.is_email_verified, isLoggedIn]);

  if (loading) {
    return (
      <LogoLoader
        logoSrc="/logo/inkriv-logo-dark.svg"
        size="lg"
        text="loading your workspace..."
      />
    );
  }

  return (
    <DashboardLayout>
      {!user?.is_email_verified ? (
        <VerifyOTP email={user?.email as string} />
      ) : (
        <Outlet />
      )}
    </DashboardLayout>
  );
}
